import { Type, Transform } from 'class-transformer'
import { DateTime } from 'luxon'
import { AddressForm } from 'types/interfaces'

type CQCPracticeForm = AddressForm & { cqc_location_id: string, name: string }

// The keys toPracticeForm() writes, for clearing them again when the selection is cleared
export const CQC_PREFILLED_FIELDS: readonly (keyof CQCPracticeForm)[] = [
  'cqc_location_id', 'name', 'address', 'line1', 'line2', 'city', 'county', 'postcode', 'country', 'latitude', 'longitude',
]

export default class CQCLocation {
  location_id!: string
  name!: string
  address!: string
  postcode!: string
  city!: string
  phone!: string
  services!: string[]
  provider_name!: string
  provider_id!: string
  latitude!: number | null
  longitude!: number | null

  @Type(() => DateTime)
  @Transform(({ value }) => DateTime.fromISO(value))
  created_at!: DateTime

  @Type(() => DateTime)
  @Transform(({ value }) => DateTime.fromISO(value))
  last_seen_at!: DateTime

  is_stale!: boolean

  toPracticeForm(): CQCPracticeForm {
    return {
      cqc_location_id: this.location_id,
      name: this.name,
      address: `${this.address}, ${this.postcode}`,  // CQC's address doesn't include postcode, so we need to add it here.
      line1: this.address,
      line2: '',
      city: this.city,
      county: '',
      postcode: this.postcode,
      country: 'United Kingdom',
      latitude: this.latitude ?? undefined,
      longitude: this.longitude ?? undefined,
    }
  }
}
